import React from 'react';
//import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import DashApp from './dashApp';
import * as serviceWorker from './serviceWorker';

const container = document.getElementById('root');
const root = createRoot(container); // Create a root.
root.render(<DashApp />); // Use the root.render method

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
window.swe = serviceWorker;
// window.addEventListener('focus', function() {
//   console.log('Window has focus');
// });
// window.addEventListener('blur', function() {
//   console.log('Window lost focus');
// });
